<template>
  <Card theme="light">
    <OrderImage :amount="value" />
    <Counter
      @minus="minus"
      @plus="value++"
      :value="value"
      light
    />
    <h3>Hoeveel pakjes bestel jij ongeveer per maand?</h3>
    <Button @click.native="next">
      Volgende
    </Button>
  </Card>
</template>

<script>
import { EventBus } from '@/EventBus'
import Card from '../Card'
import Counter from '../Counter'
import OrderImage from '../OrderImage'
import Button from '../Button'
import { trackOrders } from '@/utils/track'

export default {
  name: 'FirstContent',
  data () {
    return {
      value: 1
    }
  },
  components: {
    Card,
    Counter,
    OrderImage,
    Button
  },
  methods: {
    minus () {
      if (this.value > 0) {
        this.value--
      }
    },
    next () {
      trackOrders(this.value)
      this.$emit('next', this.value)
    }
  },
  watch: {
    value () {
      EventBus.$emit('packages-sent-change', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  z-index: 30;
}
</style>
